import { NetworkService } from "./NetworkService";
import { sessionStore } from "../store/sessionStore";
import StoreService from "./StoreService";
import { NetworkRequest } from "./NetworkRequest";

export class LoginServices {
  static async login(email, password) {
    try {
      const loginResponse = await NetworkService.request({
        alias: NetworkRequest.LoginUser,
        url: "users/login",
        method: "POST",
        data: { email, password },
      });
      sessionStore.userId = loginResponse.id;
      sessionStore.token = loginResponse.token;
      sessionStore.isTokenExpired = false;
      sessionStore.isLoggedIn = true;
      sessionStore.isDevUser = loginResponse.id.includes("@sumersoft");
    } catch (e) {
      return e;
    }
  }

  static async logout() {
    await NetworkService.request({
      alias: NetworkRequest.LogoutUser,
      url: "users/logout",
      method: "POST",
    });
    StoreService.clearStore();
    window.location.href = "/login";
  }

  static expireSession() {
    sessionStore.isTokenExpired = true;
    StoreService.clearStore();
    window.location.href = "/login";
  }

  static decodeJWT(token) {
    try {
      const payloadBase64 = token.split('.')[1];
      const paddedPayload = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
      const payloadJson = decodeURIComponent(
        atob(paddedPayload)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(payloadJson);
    } catch (e) {
      return null;
    }
  }

  static verifySession() {
    if (!sessionStore.isLoggedIn || !sessionStore.token) {
      return false;
    }

    const payload = this.decodeJWT(sessionStore.token);
    if (!payload || !payload.exp) {
      this.forceLogout();
      return false;
    }

    const currentTime = Math.floor(Date.now() / 1000);
    if (currentTime > payload.exp) {
      this.forceLogout();
      return false;
    }

    return true;
  }

  static forceLogout() {
    StoreService.clearStore();
    sessionStore.isTokenExpired = true;
    window.location.href = "/login";
  }

  static currentUser() {
    return NetworkService.request({
      alias: NetworkRequest.GetCurrentUser,
      url: "users/current",
      method: "GET",
    });
  }
}
